export default __webpack_public_path__ + "static/media/living3.0c386caf.jpg";